import { FormProps, Select as SelectProps } from '@alphabait/ui/form'
import { useState } from 'react'
import { useController } from 'react-hook-form'
import ReactSelect from 'react-select'

export type SelectOption = {
  label: string
  value: string
  data?: unknown
  disabled?: boolean
  picture?: string
  /** Optional short tag rendered beside the label (e.g. an incentive type). */
  badge?: string
}

type CustomSelectProps = {
  field: SelectProps
  formProps: FormProps
}

export function CustomSelect({ field, formProps }: CustomSelectProps) {
  const [values, setValues] = useState<SelectOption[]>()

  if (field.listen?.on) {
    formProps.listeners.addListener(
      field.listen.on,
      field.name,
      field.listen.execute(setValues),
    )
  }

  const options = values || field.options

  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    control: formProps.control,
    name: field.name,
  })

  const selected = field.options.find((option) => option.value === value)

  return (
    <ReactSelect
      id={field.name}
      options={options}
      placeholder={field.uiOptions?.placeholder}
      value={selected}
      onChange={(v) => onChange(v?.value)}
      onBlur={onBlur}
      ref={ref}
      className={`${field?.uiOptions?.className} ${
        field.hideSeparator ? 'reactSelect' : ''
      }`}
      isSearchable={field.uiOptions?.isSearchable}
      isDisabled={field.uiOptions?.disabled}
      isOptionDisabled={(option: SelectOption) =>
        option.disabled ? option.disabled : false
      }
      menuPlacement={field.menuPlacement}
      data-testid={field.uiOptions?.testId}
    />
  )
}
